import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as routerSelectors from 'connected-react-router';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { useNetworkErrorReporter, scrollToTop, PATH } from 'shared';
import { useGetConsumerApplicationsV2FeatureFlagsGlobalQuery } from 'consumer-applications-v2-api';
import { toastError, toastSuccess } from 'utils';
import { Footer, Header, SkipNavLink } from './components';
import { Header as FMAHeader } from './find-my-account/components';
import { Header as FlexFinalizeHeader } from './flex-finalize/components';
import { Header as PwaHeader } from './pay-with-alphaeon/components';
import { TreatmentEstimateHeader } from './treatment-estimate/components';
function Layout({ children }) {
    useNetworkErrorReporter({ toastError, toastSuccess });
    const location = useLocation();
    useGetConsumerApplicationsV2FeatureFlagsGlobalQuery({});
    const isInFindMyAccount = location.pathname.includes(PATH.FIND_MY_ACCOUNT);
    const isInFlexFinalize = location.pathname.includes(PATH.FLEX_FINALIZE);
    const isInPayWithAlphaeon = location.pathname.includes(PATH.PAY_WITH_ALPHAEON);
    const isInTreatmentEstimate = location.pathname.includes(PATH.TREATMENT_ESTIMATE);
    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);
    return (_jsxs("div", { className: "credit-portal", children: [_jsx(SkipNavLink, { targetId: "main-content", children: "Skip to main content" }), isInPayWithAlphaeon ? (_jsx(PwaHeader, {})) : isInFindMyAccount ? (_jsx(FMAHeader, {})) : isInFlexFinalize ? (_jsx(FlexFinalizeHeader, {})) : isInTreatmentEstimate ? (_jsx(TreatmentEstimateHeader, {})) : (_jsx(Header, {})), _jsx("main", { id: "main-content", children: children }), _jsx(Footer, {})] }));
}
function mapStateToProps(state) {
    return {
        pathname: routerSelectors.getLocation(state).pathname,
    };
}
const mapDispatchToProps = {};
export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout);
